import React from 'react';

import ThemeManager from '@dashboard/contexts/ThemeManager';
import { WarningAmberOutlined } from '@mui/icons-material';
import { AppBar, Button, Container, Link, Toolbar, Typography } from '@mui/material';

import { ErrorPageWhiteWaypointLogo } from '../components/WaypointLogo';

export default function ApplicationError() {
  return (
    <ThemeManager>
      <AppBar position="static">
        <Container>
          <Toolbar
            disableGutters
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <ErrorPageWhiteWaypointLogo />
            <Button href="https://usewaypoint.com/help" target="_blank" color="inherit">
              Help
            </Button>
          </Toolbar>
        </Container>
      </AppBar>
      <Container sx={{ py: 10, textAlign: 'center' }}>
        <WarningAmberOutlined fontSize="large" sx={{ mb: 2, color: 'brand.red' }} />
        <Typography variant="h4" gutterBottom>
          Sorry, there was an unexpected error.
        </Typography>
        <Typography>
          If this problem persists, please contact:{' '}
          <Link href="mailto: support@usewaypoint.com">support@usewaypoint.com</Link>.
        </Typography>
      </Container>
    </ThemeManager>
  );
}
